import ProductM from '../../services/product-model';

const SpreeAPIProductAdapter = {
    processList: (productsListAMS) => {
        productsListAMS.data.forEach((product) => {
            SpreeAPIProductAdapter._process(product, productsListAMS);
        });

        return productsListAMS;
    },

    processItem: (productAMS) => {
        const product = productAMS.data;

        SpreeAPIProductAdapter._process(product, productAMS);

        return product;
    },

    /*
    PRIVATE METHODS
  */
    _addMasterImages: (product, productsListAMS) => {
        if (product.master && product.master.relationships && product.master.relationships.images) {
            product.master.images = ProductM.images((product.master.relationships.images.data.map((a) => a.id)), productsListAMS);
        }
    },

    _addVariantImages: (product, productsListAMS) => {
        product.variants.forEach((variant) => {
            if (variant.relationships && variant.relationships.images) {
                variant.images = ProductM.images(variant.relationships.images.data.map((a) => a.id), productsListAMS);
            }
        });
    },

    _process: (product, AMSResponse) => {
        if (product.relationships && product.relationships.variants) {
            product.master = ProductM.masterVariant(product.relationships.default_variant.data.id, AMSResponse);
            product.variants = ProductM.variants(product.relationships.variants.data.map((a) => a.id), AMSResponse);
            product.data_extra_types = ProductM.data_extra_types(
                product.relationships.data_extra_types
                    ? product.relationships.data_extra_types.data.map((a) => a.id)
                    : [],
                AMSResponse,
            );
        }

        if (product.relationships && product.relationships.images) {
            product.images = ProductM.images(product.relationships.images.data.map((a) => a.id), AMSResponse);
        }

        SpreeAPIProductAdapter._addMasterImages(product, AMSResponse);
        SpreeAPIProductAdapter._addVariantImages(product, AMSResponse);
    },

};

export default SpreeAPIProductAdapter;



/** WEBPACK FOOTER **
 ** ./src/apis/ams-adapters/spree-api-product-adapter.js
 **/